import api from '@utils/api';
import config from '@/config';

const visitTypeService = {
  // Get init data
  getInit: async () => {
    return api.get(config.endpoints.visitTypes.init);
  },

  // Get visit types list with pagination
  getVisitTypes: async (params = {}) => {
    return api.get(config.endpoints.visitTypes.list, params);
  },

  // Get visit type by ID
  getVisitTypeById: async (id) => {
    return api.get(`${config.endpoints.visitTypes.getById}/${id}`);
  },

  // Create new visit type
  createVisitType: async (visitTypeData) => {
    return api.post(config.endpoints.visitTypes.create, visitTypeData);
  },

  // Update visit type
  updateVisitType: async (visitTypeData) => {
    return api.put(`${config.endpoints.visitTypes.update}/${visitTypeData.id}`, visitTypeData);
  },

  // Delete visit type
  deleteVisitType: async (id) => {
    return api.delete(`${config.endpoints.visitTypes.delete}/${id}`);
  },

  // Bulk delete visit types
  bulkDeleteVisitTypes: async (ids) => {
    return api.delete(config.endpoints.visitTypes.delete, { params: { ids } });
  },
};

export default visitTypeService;
